
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import HomeIcon from "@mui/icons-material/Home";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import PersonAdd from '@mui/icons-material/PersonAdd';
import QuizIcon from "@mui/icons-material/Quiz";
import BarChartIcon from '@mui/icons-material/BarChart';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import React, { useEffect, useState } from "react";
import img from '../../assets/image/outcess-logo.png';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HeaderOption from "./HeaderOption";
import { NavLink, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { getalljobs } from "../../features/Job/jobSlice";
import { useAppDispatch } from "../../useStore";



const TopNavigation = () => {
  const dispatch = useAppDispatch();



  // @ts-ignore
  const userInfo = JSON.parse(localStorage.getItem("user_ats"));
  const navigate = useNavigate();

  const [dropDown, setDropDown]: any = useState(false);

  useEffect(() => {
    if (!userInfo) {
      navigate('/')
    }
  }, [navigate, userInfo])

  useEffect(() => {
    dispatch(getalljobs());
  }, [dispatch]);




  const locale = 'en';
  const [today, setDate] = React.useState(new Date()); // Save the current date to be able to trigger an update

  React.useEffect(() => {
    const timer = setInterval(() => { // Creates an interval which will update the current data every minute
      // This will trigger a rerender every component that uses the useDate hook.
      setDate(new Date());
    }, 60 * 1000);
    return () => {
      clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
    }
  }, []);

  const day = today.toLocaleDateString(locale, { weekday: 'long' });
  const date = `${day}, ${today.getDate()} ${today.toLocaleDateString(locale, { month: 'long' })}\n\n`;

  const hour = today.getHours();
  const wish = `Good ${(hour < 12 && 'Morning') || (hour < 17 && 'Afternoon') || 'Evening'}, `;

  const time = today.toLocaleTimeString(locale, { hour: 'numeric', hour12: true, minute: 'numeric' });

  const [network, setnetwork] = useState<any>()

  window.addEventListener('offline', (e) => setnetwork('offline'));
  window.addEventListener('online', (e) => setnetwork('online'));
  useEffect(() => {
    if (network === 'online') {
      toast.success("You are back online!")
    } else if (network === 'offline') {
      toast.error("You have lost internet connection!")

    }
  }, [network])






  const navLinks = [
    { to: "/dashboard", Icon: HomeIcon, title: "Home" },
    { to: "/jobs", Icon: BusinessCenterIcon, title: "Jobs" },
    { to: "/applicants", Icon: GroupAddIcon, title: "Applicants" },
    { to: "/test", Icon: QuizIcon, title: "Test" },
    { to: "/insightscontainer", Icon: SupervisorAccountIcon, title: "Task" },
    { to: "/insights", Icon: BarChartIcon, title: "Insights" },
    { to: "/report", Icon: AssessmentIcon, title: "Report" },
    { to: "/register", Icon: PersonAdd, title: "Register" }
  ]





  return (
    <div
      id="header"
      className="header-container"
      onMouseLeave={() => setDropDown(false)}
    >
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          error: {
            duration: 20000,
          },
        }}
      />

      <div className="header_top">
        <div className="header_left">
          <img src={img} alt="logo" className="Hire-first-header-logo" />
          <div className="header_nav">
            {navLinks.map(({ to, Icon, title }) => (
              <NavLink
                key={to}
                to={to}
                style={{ textDecoration: "none" }}
                className={({ isActive }) => (isActive ? "selected" : "unselected")}
              >
                <HeaderOption
                  Icon={Icon}
                  title={title}
                  avatar={undefined}
                  dropDown={undefined}
                  setDropDown={undefined}
                />
              </NavLink>
            ))}


          </div>
        </div>
        <div className="header_right">
          <div className="verticalBar"></div>

          <HeaderOption
            // setShowModal={setShowModal}
            // showModal={showModal}
            avatar={true}
            title={userInfo?.user?.firstName}
            Icon={undefined}
            setDropDown={setDropDown}
            dropDown={dropDown}
          />
          <div className="option_time">
            {/* @ts-ignore */}
            <p className="wish-time">
              {wish} {time} <br /> {date}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopNavigation;